import {connect} from '../../../app/connect';
import IssueTypesAddAttributesModal from './IssueTypesAddAttributesModal';
import {
  getFilteredIssueTypeAttributeDefinitions,
  getIssueTypeForEdit,
  isIssueTypesAdminAddAttributesModalOpen
} from '../../../app/selectors';
import {setSelectedIssueTypeDefinitionsAction} from '../../../app/actions';

const mapStateToProps = state => {
  const issueTypeForEdit = getIssueTypeForEdit(state);
  return {
    attributeDefinitions: issueTypeForEdit ? getFilteredIssueTypeAttributeDefinitions(state) : [],
    isOpen: isIssueTypesAdminAddAttributesModalOpen(state)
  };
};

const mapDispatchToProps = {
  setSelectedIssueTypeDefinitionsAction
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IssueTypesAddAttributesModal);
